export default "__VITE_ASSET__CbwZCeFD__"